var path = '/assets/js/dashboard/trackers/openLink.html';
var html = "<div>\n    <span class=\"form-control\" ctrl-c>{{ vm.link }}</span>\n</div>\n<div></div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;